import { NeoModel, ModelBase } from '@singularsystems/neo-core';
import EventMappingLookup from './EventMappingLookup';
import StaticEventLookup from './StaticEventSearchModal/StaticEventLookup';


@NeoModel
export default class EventMappingUpdate extends ModelBase {
    public selectedEvent = new StaticEventLookup();

    public eventMappings: EventMappingLookup[] = [];
}